import type { MessageKey } from './en';

const el: Record<MessageKey, string> = {
  lang_switch_label: 'Γλώσσα',

  global_empty_state_title: 'Δεν υπάρχει τίποτα εδώ ακόμα',
  global_empty_state_description: 'Πρόσθεσε την πρώτη σου εγγραφή για να εμφανιστεί σε αυτό το cockpit.',
  pagination_go_to_page: 'Μετάβαση στη σελίδα',
  pagination_items_per_page: 'Στοιχεία ανά σελίδα',
  pagination_first_page: 'Πρώτη σελίδα',
  pagination_previous_page: 'Προηγούμενη σελίδα',
  pagination_next_page: 'Επόμενη σελίδα',
  pagination_last_page: 'Τελευταία σελίδα',

  login_welcome_back: 'Καλώς ήρθες πίσω',
  login_subtitle: 'Συνδέσου με το email και τον κωδικό σου.',
  login_email_label: 'Email',
  login_password_label: 'Κωδικός',
  login_button: 'Σύνδεση',
  login_forgot_password: 'Ξέχασες τον κωδικό;',
  login_reset_it: 'Επαναφορά',
  login_error_user_not_found: 'Το email και ο κωδικός δεν ταιριάζουν με τα στοιχεία μας.',
  login_error_wrong_password: 'Λανθασμένος κωδικός.',
  login_error_invalid_email: 'Μη έγκυρη διεύθυνση email.',
  login_error_user_disabled: 'Αυτός ο λογαριασμός έχει απενεργοποιηθεί.',
  login_error_login_failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
  login_unexpected_error: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
  login_need_account: 'Χρειάζεσαι λογαριασμό;',
  login_go_signup: 'Εγγραφή',

  signup_create_account: 'Δημιούργησε λογαριασμό',
  signup_get_started_description: 'Χρησιμοποίησε το ίδιο email που θα χρησιμοποιείς στην παραγωγή.',
  signup_display_name_label: 'Εμφανιζόμενο όνομα (προαιρετικό)',
  signup_email_label: 'Email',
  signup_password_label: 'Κωδικός',
  signup_confirm_password_label: 'Επιβεβαίωση κωδικού',
  signup_passwords_do_not_match: 'Οι κωδικοί δεν ταιριάζουν.',
  signup_button: 'Δημιουργία λογαριασμού',
  signup_already_have_account: 'Έχεις ήδη λογαριασμό;',
  signup_login_link: 'Σύνδεση',
  signup_email_already_in_use: 'Αυτό το email είναι ήδη καταχωρημένο.',
  signup_weak_password: 'Ο κωδικός είναι πολύ αδύναμος. Χρησιμοποίησε τουλάχιστον 6 χαρακτήρες.',
  signup_unexpected_error: 'Δεν ήταν δυνατή η δημιουργία λογαριασμού. Δοκίμασε ξανά.',
  signup_firestore_hint:
    'Δημιουργεί έγγραφο Firestore στο users/{uid}. Βεβαιώσου ότι οι κανόνες ασφαλείας επιτρέπουν στον συνδεδεμένο χρήστη να γράφει το δικό του προφίλ.',

  reset_password_title: 'Επαναφορά κωδικού',
  reset_password_subtitle: 'Θα σου στείλουμε email με σύνδεσμο για νέο κωδικό.',
  reset_password_email_label: 'Email',
  reset_password_send_button: 'Αποστολή συνδέσμου',
  reset_password_remembered_password: 'Θυμήθηκες τον κωδικό;',
  reset_password_back_to_login: 'Πίσω στη σύνδεση',
  reset_password_success_message:
    'Αν υπάρχει λογαριασμός για αυτό το email, θα λάβεις σύντομα σύνδεσμο επαναφοράς.',
  reset_password_error_unauthorized_domain:
    'Αυτό το domain δεν είναι εξουσιοδοτημένο για επαναφορά κωδικού. Πρόσθεσέ το στο Firebase Console → Authentication → Settings → Authorized domains.',
  reset_password_error_no_account_found: 'Δεν βρέθηκε λογαριασμός για αυτό το email.',
  reset_password_error_invalid_email: 'Εισήγαγε έγκυρη διεύθυνση email.',
  reset_password_error_link_not_sent: 'Δεν ήταν δυνατή η αποστολή συνδέσμου. Δοκίμασε αργότερα.',
  reset_password_unexpected_error: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
  reset_password_action_url_hint:
    'Όρισε το Firebase Auth action URL (continue URL) σε /confirm-password σε αυτό το origin ώστε ο σύνδεσμος να ανοίγει αυτή την οθόνη.',

  reset_password_new_password_title: 'Επίλεξε νέο κωδικό',
  reset_password_new_password_subtitle: 'Εισήγαγε και επιβεβαίωσε τον νέο κωδικό.',
  reset_password_verifying: 'Επαλήθευση συνδέσμου επαναφοράς…',
  reset_password_error_code_invalid: 'Αυτός ο σύνδεσμος είναι άκυρος ή έχει ήδη χρησιμοποιηθεί.',
  reset_password_error_code_expired: 'Αυτός ο σύνδεσμος έχει λήξει. Ζήτησε νέο.',
  reset_password_new_password_label: 'Νέος κωδικός',
  reset_password_confirm_password_label: 'Επιβεβαίωση νέου κωδικού',
  reset_password_reset_button: 'Ενημέρωση κωδικού',
  reset_password_success_reset: 'Ο κωδικός ενημερώθηκε. Ανακατεύθυνση στη σύνδεση…',
  reset_password_error_passwords_mismatch: 'Οι κωδικοί δεν ταιριάζουν.',
  reset_password_error_password_too_short: 'Χρησιμοποίησε τουλάχιστον 6 χαρακτήρες.',
  reset_password_error_weak_password: 'Ο κωδικός είναι πολύ αδύναμος. Δοκίμασε ισχυρότερο.',
  reset_password_error_generic: 'Δεν ήταν δυνατή η επαναφορά κωδικού. Δοκίμασε ξανά.',
  reset_password_request_new_link: 'Αίτηση νέου συνδέσμου επαναφοράς',
};

export default el;
